// ProductGroups — 카테고리별 묶음 목록 + 미분류. MyProductManagement.jsx 에서 그대로 옮겼다.
import React from 'react';
import { CategoryHeaderRow } from './CategoryHeaderRow';
import { TenantCategoryHeaderRow } from './TenantCategoryHeaderRow';
import { ProductRow } from './ProductRow';
import { input, iconBtnIcon, deleteBtnIcon, addBtn, catHead, catHeadTag } from './productStyles';

// onCategoryChanged(2026-10-26): 분류 이름이 바뀌면 오른쪽 '회사에 붙이기' 칸도 다시 읽게(본문이 넘긴다). 없으면 목록만.
export function ProductGroups({ ctl, canManageCategory, onCategoryChanged }) {
  const { loading, products, grouped, orphan, load } = ctl;
  const reload = onCategoryChanged || load;

  return (
    <div style={{ border: '1px solid var(--border)', borderRadius: 8, overflow: 'hidden', background: 'var(--bg-card)' }}>
      {loading && <div style={{ padding: 12, fontSize: 13, color: 'var(--text-muted)' }}>불러오는 중…</div>}
      {!loading && products.length === 0 && <div style={{ padding: 12, fontSize: 13, color: 'var(--text-muted)' }}>등록된 상품이 없습니다. 위에서 추가하세요.</div>}
      {!loading && grouped.map(({ key, name, tag, items, defaultProductId }) => (items.length === 0 ? null : (
        <div key={key}>
          {/* 손님 테넌트(직접 적은 분류)는 한꺼번에 이름 고치기·비우기 머리줄(2026-10-26), 운영사는 카테고리 표 머리줄 */}
          {ctl.freeCategory
            ? <TenantCategoryHeaderRow name={name} count={items.length} onChanged={reload} />
            : <CategoryHeaderRow group={{ key, name, tag, defaultProductId }} items={items} canManage={canManageCategory}
              styles={{ catHead, catHeadTag, iconBtnIcon, deleteBtnIcon, input, addBtn }} onChanged={reload} />}
          {items.map((p) => <ProductRow key={p.id} p={p} fallbackCat={name} ctl={ctl} />)}
        </div>
      )))}
      {!loading && orphan.length > 0 && (
        <div>
          <div style={catHead}>미분류</div>
          {orphan.map((p) => <ProductRow key={p.id} p={p} fallbackCat="" ctl={ctl} />)}
        </div>
      )}
    </div>
  );
}
